// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"LoaderComponent_loaderWrapper__hm-Xx","ldsSpinner":"LoaderComponent_ldsSpinner__3Fwvm"};